import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faUserPlus } from "@fortawesome/free-solid-svg-icons";

import Utils from "../../configs/Utils";
import { Workspace } from "../../Models/Workspace";
import PopupModal from "../Common/Popup";
import WorkspaceMemberForm from "./WorkspaceMemberForm";

interface WorkspaceListItemProps {
  index: number;
  workspace: Workspace;
  workspaceList: Workspace[];
  setWorkspaceList: React.Dispatch<React.SetStateAction<Workspace[]>>;
}

const WorkspaceListItem: React.FC<WorkspaceListItemProps> = ({ ...props }) => {
  const { index, workspace, workspaceList, setWorkspaceList } = props;
  const [memberPopupShow, setMemberPopupShow] = useState(false);

  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td><strong>{workspace.name}</strong></td>
        <td>{workspace.description || '-'}</td>
        <td>
          <div className="d-flex align-items-center">
            {workspace.members && workspace.members.length > 0 ? (
              workspace.members.slice(0, 5).map((member, idx) => {
                const userObj = member.user as any;
                // Using email as fallback for initial if fullName not available
                const displayName = userObj?.fullName || member.email || "Unknown User";
                const initial = displayName.charAt(0).toUpperCase();
                const bgColor = Utils.stringToColor(displayName);

                return (
                  <OverlayTrigger
                    key={idx}
                    placement="top"
                    overlay={<Tooltip id={`tooltip-${workspace._id}-${idx}`}>{displayName}</Tooltip>}
                  >
                    <div
                      className="rounded-circle text-white d-flex align-items-center justify-content-center me-1"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: bgColor,
                        fontSize: '14px',
                        fontWeight: 'bold',
                        border: '2px solid #fff',
                        marginLeft: idx > 0 ? '-10px' : '0'
                      }}
                    >
                      {initial}
                    </div>
                  </OverlayTrigger>
                );
              })
            ) : (
              <span className="text-muted">No members</span>
            )}
            {workspace.members && workspace.members.length > 5 && (
              <div
                className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                style={{
                  width: '32px',
                  height: '32px',
                  fontSize: '12px',
                  border: '2px solid #fff',
                  marginLeft: '-10px',
                  zIndex: 0
                }}
              >
                +{workspace.members.length - 5}
              </div>
            )}
          </div>
        </td>
        <td>{workspace.createdAt ? Utils.dateFormat(workspace.createdAt, true) : '-'}</td>
        <td className="text-inline text-end">
          <Button
            className="ms-1"
            size="sm"
            variant="outline-primary"
            title="Add Member"
            onClick={() => setMemberPopupShow(true)}
          >
            <FontAwesomeIcon icon={faUserPlus} />
          </Button>
          <Button className="ms-1" size="sm" variant="outline-secondary" title="Edit">
            <FontAwesomeIcon icon={faPenToSquare} />
          </Button>
        </td>
      </tr>

      <PopupModal title={`Add Member to ${workspace.name}`} popupShow={memberPopupShow} setPopupShow={setMemberPopupShow}>
        <WorkspaceMemberForm workspaceId={workspace._id} setPopupShow={setMemberPopupShow} />
      </PopupModal>
    </>
  );
}

export default WorkspaceListItem;
